import React from 'react';

export default function Cake() {
	return (
		<g>
			<path fill="#FFEAAE" d="M31.0144,366.55817c-3.23416-13.16168-3.1056-25.93146,0.21358-39.08136l72.21318,13.05627
				c0,0-0.10125,39.09985-0.57729,39.01431L31.0144,366.55817z" />
			<path fill="#FFFFFF" d="M30.03949,327.13174c8.83332-9.3699,26.00292-15.04514,39.38206-14.8898l35.06902,28.29114
				L30.03949,327.13174z" />
			<path fill="#F8FAFF" d="M28.96184,332.00317l75.83931,13.82837c0.49878-1.76868,0.241-3.69891-0.31051-5.29846l-74.45117-13.40131
				C29.62957,328.75549,29.27166,330.37927,28.96184,332.00317z" />
			<path fill="#F8FAFF" d="M28.69353,353.59875l0.01953-0.22705c0.18359-2.14844,0.38623-3.61523,0.60156-5.16846
				c0.15039-1.08545,0.30908-2.23193,0.47607-3.7124l0.03027-0.26562l74.88623,13.4585l0.02979,0.17236
				c-0.32788,2.89172-0.32837,5.94293-0.00049,9.1543l-0.04346,0.24707L28.69353,353.59875z" />
			<path fill="#F8FAFF" d="M34.94548,328.01331c-0.60107-0.10797-4.90601-0.88153-4.90601-0.88153
				c-3.36084,13.31488-3.35791,26.63593,0,39.96295l5.41455,0.97296l-0.53467-1.94989
				c-3.18018-12.62158-3.18018-25.40918-0.01562-37.94922L34.94548,328.01331z" />
			<path fill="#FFEAAE" d="M34.91936,366.1178l0.53467,1.94989l68.15854,12.3118c0.43311,0.07782,0.85276-0.2178,0.91466-0.65347
				c0.56614-3.98511,0.99074-8.07504,0.41356-12.29294c-0.03223-0.23547-0.21498-0.42578-0.44892-0.46783L32.85711,354.0932
				C33.22673,358.10925,33.91253,362.12189,34.91936,366.1178z" />
			<path fill="#FFEAAE" d="M33.86492,332.88422c-0.7561,4.01398-1.1875,8.04791-1.2998,12.08826l71.76747,12.89584
				c0.30229,0.05432,0.59546-0.1521,0.6423-0.45566c0.5731-3.71353,0.56909-7.44281,0.00223-11.18747
				c-0.05234-0.34573-0.32418-0.62112-0.66834-0.68298L33.86492,332.88422z" />
			<path fill="#A2D8C0" d="M52.32873,338.13672c-0.96387,0-1.74805,0.78369-1.74805,1.74707s0.78418,1.74756,1.74805,1.74756
				c0.96289,0,1.74707-0.78418,1.74707-1.74756S53.29162,338.13672,52.32873,338.13672z" />
			<path fill="#A2D8C0" d="M84.36388,343.85107c-0.96289,0-1.74707,0.78369-1.74707,1.74707s0.78418,1.74707,1.74707,1.74707
				c0.96387,0,1.74805-0.78369,1.74805-1.74707S85.32775,343.85107,84.36388,343.85107z" />
			<path fill="#A2D8C0" d="M95.34924,368.47998c-0.96289,0-1.74707,0.78369-1.74707,1.74707s0.78418,1.74707,1.74707,1.74707
				c0.96387,0,1.74805-0.78369,1.74805-1.74707S96.3131,368.47998,95.34924,368.47998z" />
			<path fill="#A2D8C0" d="M67.48888,367.479c-0.96387,0-1.74805,0.78418-1.74805,1.74756s0.78418,1.74707,1.74805,1.74707
				c0.96289,0,1.74707-0.78369,1.74707-1.74707S68.45177,367.479,67.48888,367.479z" />
			<circle fill="#A2D8C0" cx="61.60412" cy="363.30859" r="1.74707" />
			<circle fill="#A2D8C0" cx="45.29357" cy="360.89502" r="1.74707" />
			<circle fill="#FC7E7E" cx="45.41759" cy="342.51709" r="1.74707" />
			<path fill="#FC7E7E" d="M72.27795,341.77051c-0.96289,0-1.74707,0.78418-1.74707,1.74756s0.78418,1.74707,1.74707,1.74707
				s1.74707-0.78369,1.74707-1.74707S73.24084,341.77051,72.27795,341.77051z" />
			<path fill="#FC7E7E" d="M92.47131,350.10205c-0.96289,0-1.74707,0.78369-1.74707,1.74707s0.78418,1.74756,1.74707,1.74756
				s1.74707-0.78418,1.74707-1.74756S93.4342,350.10205,92.47131,350.10205z" />
			<path fill="#FC7E7E" d="M87.4381,370.1123c-0.96289,0-1.74707,0.78369-1.74707,1.74707s0.78418,1.74707,1.74707,1.74707
				c0.96387,0,1.74805-0.78369,1.74805-1.74707S88.40197,370.1123,87.4381,370.1123z" />
			<path fill="#FC7E7E" d="M55.40197,365.39893c-0.96289,0-1.74707,0.78369-1.74707,1.74707s0.78418,1.74756,1.74707,1.74756
				c0.96387,0,1.74805-0.78418,1.74805-1.74756S56.36584,365.39893,55.40197,365.39893z" />
			<path fill="#C8B8F2" d="M38.25549,335.88867c-0.96289,0-1.74707,0.78369-1.74707,1.74707s0.78418,1.74756,1.74707,1.74756
				s1.74707-0.78418,1.74707-1.74756S39.21838,335.88867,38.25549,335.88867z" />
			<path fill="#C8B8F2" d="M60.4508,343.52588c-0.96289,0-1.74707,0.78369-1.74707,1.74707s0.78418,1.74756,1.74707,1.74756
				s1.74707-0.78418,1.74707-1.74756S61.41369,343.52588,60.4508,343.52588z" />
			<circle fill="#C8B8F2" cx="78.16271" cy="349.43555" r="1.74707" />
			<circle fill="#C8B8F2" cx="101.51134" cy="349.29053" r="1.74707" />
			<path fill="#C8B8F2" d="M101.51134,373.36084c-0.96289,0-1.74707,0.78418-1.74707,1.74756s0.78418,1.74707,1.74707,1.74707
				s1.74707-0.78369,1.74707-1.74707S102.47424,373.36084,101.51134,373.36084z" />
			<circle fill="#C8B8F2" cx="79.31603" cy="367.47119" r="1.74707" />
			<path fill="#C8B8F2" d="M38.25549,361.70654c-0.96289,0-1.74707,0.78369-1.74707,1.74707s0.78418,1.74756,1.74707,1.74756
				s1.74707-0.78418,1.74707-1.74756S39.21838,361.70654,38.25549,361.70654z" />
			<path fill="#b4edd2" d="M53.57673,295.68884h-0.01314v26.36365c0,0.00226,0,0.00916,0,0.01025
				c0,0.00305,0.0025,0.00586,0.0025,0.00885c0.01439,0.73932,1.80632,1.3374,4.01807,1.3374
				c1.90017,0,3.48375-0.44305,3.90295-1.03668c0.0025-0.00348,0.00688-0.00659,0.00938-0.01007
				c0.0657-0.09662,0.10762-0.19623,0.10762-0.2995v-26.3739H53.57673z" />
			<ellipse fill="#b4edd2" cx="57.58385" cy="295.68884" rx="4.02027" ry="1.34625" />
			<path fill="#FFFFFF" d="M58.74142,295.66122c0,0,0.00083,0.20026-1.15734,0.20026c-1.15817,0-1.15817-0.20026-1.15817-0.20026
				v-4.18814c0,0,0-0.39059,1.15776-0.39059s1.15776,0.39059,1.15776,0.39059V295.66122z" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/Cake.js